"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./SelectField.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Our main component
var SelectField = function SelectField(props) {
  // State to manage the dropdown visibility
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1]; // Reference to the component


  var selectFieldRef = (0, _react.useRef)(null); // Toggle dropdown visibility

  var toggleDropdown = function toggleDropdown() {
    return setIsOpen(!isOpen);
  }; // Handle option click


  var handleOptionClick = function handleOptionClick(value) {
    if (props.onChange) {
      props.onChange(value);
    }

    setIsOpen(false); // Close the dropdown after selection
  }; // Close dropdown if clicked outside


  var handleClickOutside = function handleClickOutside(event) {
    if (selectFieldRef.current && !selectFieldRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  }; // Add event listener for clicks outside the component


  (0, _react.useEffect)(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: selectFieldRef,
    className: "selectField ".concat(props.className || "", " ").concat(props.disabled ? "disabled" : "", " ").concat(props.template ? "temp_".concat(props.template) : "", " ").concat(isOpen ? "active" : "") // Add 'active' class when isOpen is true

  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectFieldSelected",
    onClick: toggleDropdown
  }, props.active || "Select", " ", /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "ArrowFillDown"
  })), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    className: "selectFieldOptions"
  }, props.options && props.options.map(function (value, index) {
    return value ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "selectFieldOption",
      key: index,
      onClick: function onClick() {
        return handleOptionClick(value);
      }
    }, _typeof(value) === "object" ? Object.entries(value).map(function (_ref, idx) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];

      return key !== "id" && /*#__PURE__*/_react["default"].createElement("div", {
        key: idx
      }, val);
    }) : value) : null;
  })));
};

var _default = SelectField;
exports["default"] = _default;